$(document).ready(function () {
  // Show submit button when variant is changed
  $(document).on('change', '.variant-input-wrapper select', function () {
    $(document).find('.product-form__submit').show();
    $(document).find('.btn-choose-options').hide();
  });

  // Calculate total price
  function calculatePrice() {
    $(document).find('.color-side-select ul li').each(function () {
      console.log($(this).find('input').val() + ' ' + $(this).find('input').attr('disabled'));
      $(document).find('.color-side-select input').prop('checked', false);
      if ($(this).find('input').attr('disabled') !== 'disabled') {
        $(this).find('input').closest('label').trigger('click');
        return false;
      }
    });

    var mainPrice = parseInt($('#product_main_price').attr('data-price')),
        symbol = $('#product_main_price').attr('data-symbol');

    if (
      $(document).find('.bumper-item.bumper-product').hasClass('selected') &&
      !$(document).find('.bumper-design').hasClass('hidden')
    ) {
      mainPrice += parseInt($(document).find('.bumper-design').attr('data-price'));
    }

    $(document).find('.inner-addons .product_item').each(function () {
      if ($(this).find('input[type="checkbox"]').is(':checked')) {
        var price = $(this).attr('data-price');
        mainPrice += parseInt(price);
      }
    });

    console.log(mainPrice);
    var formattedPrice = theme.Currency.formatMoney(mainPrice, theme.settings.moneyFormat);
    $(document).find('.addcart-btn .btn-price').html(formattedPrice);
  }

  // Checkbox changes trigger price recalculation
  $(document).on('change', '.product_item [type=checkbox]', calculatePrice);

  // Handle bumper item selection
  $(document).on('click', '.bumper-item', function () {
    var parent = $(this).closest('.bumper');
    $(parent).find('.bumper-item').removeClass('selected');
    $(this).addClass('selected');

    if ($(this).hasClass('bumper-product')) {
      $('.color-side-select input[value="Clear"], .color-side-select input[value="White"]').attr('disabled', 'disabled');
      var bumperPricePlus = $('.bumper-design').attr('data-price');
      $(document).find('.addcart-btn .btn-price').html(bumperPricePlus);
      $('.color-side-select').find('input[value="Black"]').prop('checked', true);
      $(document).find('.bumper-input').html('<input type="hidden" name="properties[Bumper upgrade]" value="Yes">');
    } else if ($(this).hasClass('bumper-product-magsafe')) {
      $('.color-side-select input[value="Clear"], .color-side-select input[value="White"]').attr('disabled', 'disabled');
      var magPrice = $('.bumper-design').attr('data-mprice');
      $(document).find('.addcart-btn .btn-price').html(magPrice);
      $('.color-side-select').find('input[value="Black"]').prop('checked', true);
      $(document).find('.bumper-input').html('<input type="hidden" name="properties[MagSafe upgrade]" value="Yes">');
    } else {
      var bumperMainPrice = $('.bumper-design').attr('data-mainPrice');
      $(document).find('.addcart-btn .btn-price').html(bumperMainPrice);
      $('.color-side-select input[value="Clear"], .color-side-select input[value="White"]').removeAttr('disabled');
      $(document).find('.bumper-input').html('');
    }

    calculatePrice();
  });

  // Check if bumper is available for a variant
  function checkifBumper(value) {
    if ($(document).find('[name="bumper_variant"] option[data-value="' + value + '"]').length > 0) {
      $('.bumper-design, .bumper-product-impact').removeClass('hidden');
      $(document).find('[name="bumper_variant"] option[data-value="' + value + '"]').prop('selected', true);
    } else {
      $('.bumper-design, .bumper-product-impact').addClass('hidden');
      $(document).find('[name="bumper_variant"] option[data-value=""]').prop('selected', true);
    }

    if ($(document).find('[name="mag_variant"] option[data-value="' + value + '"]').length > 0) {
      $('.bumper-product-magsafe, .bumper-design').removeClass('hidden');
      $(document).find('[name="mag_variant"] option[data-value="' + value + '"]').prop('selected', true);
    } else {
      $('.bumper-product-magsafe').addClass('hidden');
      $(document).find('[name="mag_variant"] option[data-value=""]').prop('selected', true);
    }

    var arrayVals = [
      'iphone-14', 'iphone-14-plus', 'iphone-14-pro', 'iphone-14-pro-max',
      'iphone-13', 'iphone-13-pro', 'iphone-13-pro-max', 'iphone-13-mini',
      'iphone-12-12-pro', 'iphone-12-pro-max', 'iphone-12-mini',
      'iphone-11', 'iphone-11-pro', 'iphone-11-pro-max',
      'iphone-x-xs', 'iphone-xs-max', 'iphone-xr',
      'iphone-6-7-8-se', 'iphone-6-plus-7-plus-8-plus', 'iphone-5-5s-se-2016'
    ];

    if ($(document).find('.product_item select option[data-value="' + value + '"]').length > 0) {
      $(document).find('.product_item select option[data-value="' + value + '"]').prop('selected', true);
      $('[data-handle="tempered-glass-screen-protector"]').removeClass('hidden');
    } else {
      $('[data-handle="tempered-glass-screen-protector"]').addClass('hidden');
    }

    if ($.inArray(value, arrayVals) !== -1) {
      $('[data-handle="lightning-cable-1m"]').removeClass('hidden');
      $('[data-handle="usb-c-cable-1m"]').addClass('hidden');
    } else {
      $('[data-handle="lightning-cable-1m"]').addClass('hidden');
      $('[data-handle="usb-c-cable-1m"]').removeClass('hidden');
    }

    $('.addons').removeClass('hidden');
    calculatePrice();
  }

  var valueBump = $(document).find('.variant-input-wrapper[data-option-index="option1"] .select').val();
  checkifBumper(valueBump);

  $(document).on('change', '.variant-input-wrapper[data-option-index="option1"] .select', function () {
    var value = $(this).val();
    console.log(value);
    checkifBumper(value);
  });

  // Popup and personalisation logic
  $(document).on("click", ".overlay-pop", function () {
    $("#personal-popup").hide();
  });

  $(document).on('click', '.free-personalization .btn[data-person="added"]', function () {
    $(this).text($(this).attr('data-text'));
    $('.initla-hidden-inputs').html('');
  });

  $(document).on("click", ".free-personalization .btn", function () {
    var image = $(document).find('.main-product-image').attr('src');
    if ($(document).find('.product__media.selected img').length > 0) {
      image = $(document).find('.product__media.selected img').attr('src');
    }
    if( $(this).attr('data-image') ){
      image = $(this).attr('data-image');
    }
    $("#personal-popup").find('.person-image').attr('src', image);
    $("#personal-popup").show();
    $('.tab-pops .tab-popup').hide();
    $('.tab-pops .tab-popup, .buttons-pop ul li').removeClass('selected');
    $('.tab-pops .tab-popup:first-child, .buttons-pop ul li:first-child').show().addClass('selected');
    updateProgress();

  });

  $(document).on("keyup", "#initials_textinput", function () {
    $('.personalization-text').text($(this).val());
  });

  $("#initials_textinput").on("cut copy paste", function (e) {
    e.preventDefault();
  });

  $("#initials_textinput").bind("keydown", function (e) {
    switch (e.keyCode) {
      case 8: case 9: case 13: case 37: case 38: case 39: case 40:
        break;
      default:
        if (!RegExp("^[a-zA-Z0-9/]+$").test(e.key)) {
          e.preventDefault();
          alert("Sorry, only letters or numbers allowed. No emojis or special characters");
          return false;
        }
    }
  });

  $(document).on('change', '#initials_size', function () {
    var value = $(this).val();
    if (value === 'large') {
      $('.personalization-text').css('font-size', '30px');
    } else if (value === 'medium') {
      $('.personalization-text').css('font-size', '20px');
    } else {
      $('.personalization-text').css('font-size', '10px');
    }
  });

  function setInitialsColour(value) {
    var isHex = /^#([0-9A-Fa-f]{6})$/.test(value);
    var hex;
    if (isHex) {
      hex = value.toUpperCase();
    } else {
      switch ((value || '').toLowerCase()) {
        case 'white': hex = '#FFFFFF'; break;
        case 'pink': hex = '#F9C2FF'; break;
        case 'grey': hex = '#999999'; break;
        case 'blue': hex = '#A5B0FF'; break;
        case 'yellow': hex = '#FEFF84'; break;
        default: hex = '#000000';
      }
    }
    $('.personalization-text').css('color', hex);
    $('#initials_colour_hex').val(hex);
  }

  $(document).on('input change', '#initials_color', function () {
    setInitialsColour(this.value);
  });

  $(function () {
    setInitialsColour($('#initials_color').val() || '#000000');
  });

  $(document).on('click', '.buttons-pop [data-tab="colour"]', function () {
    setTimeout(function () {
      setInitialsColour($('#initials_color').val());
    }, 0);
  });

  $(document).on('change', '#initials_font', function () {
    $('.personalization-text').css('font-family', "'" + $(this).val() + "'");
  });

  function addProperties() {
    var name = $('#initials_textinput').val(),
        pos = $('#initials_position').val(),
        size = $('#initials_size').val(),
        color = $('#initials_color').val(),
        font = $('#initials_font').val();

    var hiddenInputs =
      '<input type="hidden" name="properties[Your initials]" value="' + name + '">' +
      '<input type="hidden" name="properties[Initials Position]" value="' + pos + '">' +
      '<input type="hidden" name="properties[Initials Size]" value="' + size + '">' +
      '<input type="hidden" name="properties[Initials Colour]" value="' + color + '">' +
      '<input type="hidden" name="properties[Initials Font]" value="' + font + '">';

    $('.initla-hidden-inputs').html(hiddenInputs);
    $('.free-personalization .btn').attr('data-person', 'added')
                                   .text($('.free-personalization .btn').attr('data-rtext'));
    $("#personal-popup").hide();
  }

  function handleTabs(selector, parent, action){
  var textCustom = $('#initials_textinput').val();
  if(textCustom.length > 2){
    alert('Only two characters allowed');
    return false;
  }
  if( $(selector).hasClass('finish-button') ){
    ///DO FINISH TASK
    addProperties();
    return false;
  }
  $(parent).find('.tab-popup').removeClass('selected').hide();
  if(action == 'prev'){
    $(selector).closest('.tab-popup').prev('.tab-popup').show().addClass('selected');
  }else{
    $(selector).closest('.tab-popup').next('.tab-popup').show().addClass('selected');
  }

  var selectedTab = $(document).find('.tab-pops .tab-popup.selected').attr('data-tabc');
  $(document).find('.buttons-pop ul li').removeClass('selected');
  $(document).find('.buttons-pop ul li[data-tab="'+selectedTab+'"]').addClass('selected');

  /* NEW: keep progress bar state up to date */
  updateProgress();
}


  $(document).on('click', '.popup-close', function () {
  $('.initla-hidden-inputs').html('');
  $('.free-personalization .btn').removeAttr('data-person')
    .text($('.free-personalization .btn').attr('data-text'));
  $("#personal-popup").hide();
});

// Progress helper: mark completed/current based on the active tab
function updateProgress(){
  var steps = ['initials','position','size','colour','font'];
  var activeKey = $('.tab-pops .tab-popup.selected').attr('data-tabc');
  var idx = Math.max(0, steps.indexOf(activeKey));
  var $items = $('.buttons-pop ul li');

  $items.removeClass('completed selected');
  $items.each(function(i){
    if (i < idx) $(this).addClass('completed');
    if (i === idx) $(this).addClass('selected');
  });
}

// Make the step labels jump to their tab
$(document).on('click', '.buttons-pop ul li', function(){
  var key = $(this).attr('data-tab');
  if(!key) return;
  $('.tab-pops .tab-popup').hide().removeClass('selected');
  $('.tab-pops .tab-popup[data-tabc="'+key+'"]').show().addClass('selected');
  updateProgress();
});



$(document).on('click', '.buttons-pop ul li', function(){
  var tab = $(this).attr('data-tab');
  var $target = $('.tab-pops .tab-popup[data-tabc="'+tab+'"]');
  if(!$target.length) return;

  $('.tab-pops .tab-popup').hide().removeClass('selected');
  $target.show().addClass('selected');

  $('.buttons-pop ul li').removeClass('selected');
  $(this).addClass('selected');

  updateProgress();
});



  $(document).on("click", ".back-button", function () {
    handleTabs($(this), $(this).closest('.tab-pops'), 'prev');
  });

  $(document).on("click", ".tab-popup .btn", function () {
    handleTabs($(this), $(this).closest('.tab-pops'), 'next');
  });

  $(".left-tab-main li").on("mouseover", function () {
    var tabInd = $(this).attr("data-tab"),
        parent = $(this).closest(".menu-disp-flex");
    $(parent).find(".menu-items-tabs .menu-tabs").hide();
    $(parent).find('.menu-items-tabs .menu-tabs[data-menu_tab="' + tabInd + '"]').show();
  });
});
